export default {
  mainContainer: 'search-header__results-count fds-u-pt2',
  seoHeading:
    'fds-c-text-heading -color-light -size-xs h-remove-margin -weight-normal',
  seoSubHeading:
    'fds-c-text-heading -color-light -size-xs -weight-normal fds-u-hide-small-and-below',
  suggestionsContainer: 'search-header__extras',
  authorText: 'author-search-result'
}
